import { render } from "./business-card-scan-modal.vue?vue&type=template&id=4351a23d"
import script from "./business-card-scan-modal.vue?vue&type=script&lang=js"
export * from "./business-card-scan-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__